// Most non-tablet mobile devices will have 'Mobi' in the User Agent (per Mozilla docs)
const MOBILE_REGEX = /Mobi/i;

// Some tablet devices with desktop-width size screens will not have 'Mobi' in the User Agent
// Check User Agent for Android and iOS substrings in these fallback cases
const ANDROID_REGEX = /Android/i;
const IOS_REGEX = /iPad|iPhone|iPod/i;

export const isTouchScreen = () => window.navigator.maxTouchPoints > 0;
export const isMobileUserAgent = () =>
  MOBILE_REGEX.test(window.navigator.userAgent);
export const isAndroidUserAgent = () =>
  ANDROID_REGEX.test(window.navigator.userAgent);
export const isIOSUserAgent = () =>
  IOS_REGEX.test(window.navigator.userAgent) && !(window as any).MSStream;

export const isIEUserAgent = () => {
  // Check the userAgent property of the window.navigator object
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE '); // IE 10 or older
  const trident = ua.indexOf('Trident/'); // IE 11
  return msie > 0 || trident > 0;
};

export const isMobileDevice = () => {
  if (!isTouchScreen()) return false;
  if (isMobileUserAgent()) return true;
  if (isAndroidUserAgent()) return true;
  if (isIOSUserAgent()) return true;
  // Default to false when none of the above conditions are met
  // Note this may return false for large tablets with OS that fall outside Android and iOS
  return false;
};
